// full updated code (starts here)
import React, { useState, useEffect } from "react";
import Select from "react-select";
import classes from './MakeJournal.module.css';
import HeaderNav from '../../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../../Components/Footer/Footer";
import { Trash2 } from "lucide-react";
import axios from "axios";
import { BASE_URL } from "../../../Components/API/Api";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";

const MakeJournal = () => {
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const [journalRows, setJournalRows] = useState([
    {
      account: null,
      account_id: "",
      account_code: "",
      description: "",
      direction: "", // "1" for Debit, "2" for Credit
      amount: ""
    }
  ]);
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [reference, setReference] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [bearer, setBearer] = useState('');


  const readData = async () => {
    try {
      const value = localStorage.getItem('authToken');


      if (value !== null) {
        setBearer(value);
        console.log(value);
      }

    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);
  // Fetch accounts for dropdown
  useEffect(() => {
    const fetchAccounts = async () => {
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/v1/account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        // Normalize possible response shapes
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === 'object' && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setAccounts(list);
      } catch (err) {
        setAccounts([]);
      } finally {
        setAccountsLoading(false);
      }
    };
    if (token) fetchAccounts();
  }, [token]);

  // Add a new journal row
  const handleAddRow = () => {
    setJournalRows(prev => [
      ...prev,
      {
        account: null,
        account_id: "",
        account_code: "",
        description: "",
        direction: "",
        amount: ""
      }
    ]);
  };

  // Remove a journal row
  const handleDeleteRow = (idx) => {
    setJournalRows(prev => prev.filter((_, i) => i !== idx));
  };

  // Handle changes in a journal row
  const handleRowChange = (idx, field, value) => {
    setJournalRows(prev => {
      const updated = [...prev];
      if (field === "account") {
        const acc = accounts.find(a => a.id === value?.value);
        updated[idx].account = value;
        updated[idx].account_id = acc?.id || "";
        updated[idx].account_code = acc?.gl_code || "";
      } else if (field === "direction") {
        updated[idx].direction = value;
      } else {
        updated[idx][field] = value;
      }
      return updated;
    });
  };

  // Calculate totals
  const totalDebit = journalRows
    .filter(row => row.direction === "1")
    .reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
  const totalCredit = journalRows
    .filter(row => row.direction === "2")
    .reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);

  // Save journal entries
  const handleSaveJournal = async () => {
    // Validation
    if (
      !transactionDate ||
      journalRows.some(
        row =>
          !row.account_id ||
          !row.direction ||
          !row.amount ||
          !row.description
      )
    ) {
      Swal.fire("Missing Fields", "Please fill all required fields.", "warning");
      return;
    }

    const payload = {
      jv_number: reference,
      all_debit: totalDebit,
      all_credit: totalCredit,
      account_id: journalRows.map(row => String(row.account_id)),
      direction: journalRows.map(row => row.direction),
      transaction_date: transactionDate,
      description: journalRows.map(row => row.description),
      amount: journalRows.map(row => parseFloat(row.amount)),
    };

    setIsSaving(true);
    try {
      const res = await axios.post(`${BASE_URL}/v1/journal/post-entries`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      Swal.fire({
        imageUrl: verified,
        title: "Success!",
        text: res.data.message || "Journal entry saved successfully!",
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
        preConfirm: () => {
          Swal.close();
        },
      });
      setJournalRows([
        {
          account: null,
          account_id: "",
          account_code: "",
          description: "",
          direction: "",
          amount: ""
        }
      ]);
      setTransactionDate("");
    } catch (error) {
      const msg = error?.response?.data?.message || "Network error";
      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Failed!",
        confirmButtonText: "Okay",
        text: JSON.stringify(msg),
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myDeclineButton,
        },
        allowOutsideClick: false,
        preConfirm: () => {
          Swal.close();
        },
      });
    } finally {
      setIsSaving(false);
    }
  };

  // Account options for react-select
  const accountOptions = (accounts || []).map(acc => ({
    value: acc?.id ?? acc?.account_id ?? acc?.gl_id,
    label: acc?.gl_name, // use gl_name for account name field
    code: acc?.gl_code ?? acc?.code ?? acc?.account_code ?? ""
  })).filter(opt => opt.value !== undefined && opt.value !== null && opt.value !== "" && opt.label);


  const fetchInitialData = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const [refRes, currencyRes] = await Promise.all([
        axios.get(`${BASE_URL}/v1/generate-sales-invoice-code`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }),

      ]); if (refRes?.data?.data) setReference(refRes.data.data.toString());
      if (refRes?.data) {
        const payload = refRes.data;
        const d =
          payload?.data ??
          payload?.code ??
          payload?.reference ??
          payload?.number ??
          payload?.data?.code;
        let ref = "";
        if (typeof d === "string" || typeof d === "number") {
          ref = d;
        } else if (d && typeof d === "object") {
          ref = d.code || d.reference || d.number || "";
        }
        setReference(ref ? String(ref) : "");
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(() => {
    if (bearer)
      fetchInitialData();
  }, [bearer]);
  useEffect(() => {
    if (token) fetchInitialData();
  }, [token]);

  return (
    <div>
      <HeaderNav />
      <div className={classes.Container}>
        <header className={classes.Header}>
          <h2 className={classes.Title}>Make Journal Entry</h2>
        </header>
        <form className={classes.form}>
          <div className={classes.group2}>
            <label>JV Number</label>
            <input type="text" value={reference} readOnly />
          </div>
          <div className={classes.group1}>
            <label>Transaction Date</label>
            <input
              type="date"
              value={transactionDate}
              onChange={e => setTransactionDate(e.target.value)}
              required
            />
          </div>
        </form>
        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th>Account Name</th>
                <th>Account Code</th>
                <th>Description</th>
                <th>DR/CR</th>
                <th>Amount</th>
                <th>
                  <button type="button" className={classes.addRowBtn} onClick={handleAddRow}>+</button>
                </th>
              </tr>
            </thead>
            <tbody>
              {journalRows.map((row, idx) => (
                <tr key={idx}>
                  <td>
                    <Select
                      isLoading={accountsLoading}
                      options={accountOptions}
                      value={accountOptions.find(opt => opt.value === row.account_id) || null}
                      onChange={option => handleRowChange(idx, "account", option)}
                      placeholder="Select account..."
                      noOptionsMessage={() => accountsLoading ? 'Loading accounts...' : 'No accounts found'}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={row.account_code}
                      readOnly
                      className={classes.totalInput}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={row.description}
                      onChange={e => handleRowChange(idx, "description", e.target.value)}
                      placeholder="Description"
                      required
                      className={classes.totalInputdesc}
                    />
                  </td>
                  <td>
                    <select
                      value={row.direction}
                      onChange={e => handleRowChange(idx, "direction", e.target.value)}
                      required
                    >
                      <option value="">Select</option>
                      <option value="1">Debit</option>
                      <option value="2">Credit</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      value={row.amount}
                      onChange={e => handleRowChange(idx, "amount", e.target.value)}
                      placeholder="0.00"
                      required
                      className={classes.totalInput}
                    />
                  </td>
                  <td>
                    <Trash2 size={16} onClick={() => handleDeleteRow(idx)} className={classes.deleteIcon} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className={classes.foot}>
            <div className={classes.Footer}>
              {/* <div className={`${classes.footerSection} ${classes.comments}`}>
                <label>Message</label>
                <textarea className={classes.commentsBox}></textarea>
              </div> */}

              <div className={`${classes.footerSection} ${classes.summary}`}>
                <div className={classes.grouppp}>
                  <label>Total Debit:</label>
                  <input
                    type="text"
                    value={totalDebit.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>
                <div className={classes.grouppp}>
                  <label>Total Credit:</label>
                  <input
                    type="text"
                    value={totalCredit.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>
              </div>

            </div>
            <div className={classes.actionButtons}>
              <button className={classes.cancelButton} type="button" onClick={() => setJournalRows([{
                account: null,
                account_id: "",
                account_code: "",
                description: "",
                direction: "",
                amount: ""
              }])}>
                Cancel
              </button>
              <button
                className={classes.saveButton}
                type="button"
                onClick={handleSaveJournal}
                disabled={isSaving}
              >
                {isSaving ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      className="me-2"
                    />
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
        <Footer />
    </div>
  );
};

export default MakeJournal;
